<template>
  <div class="Crmactivemanage-crmTicketMange">
    <PageNav>
      <div id="page-crmTicketMange">
        <div class="head-tab--nav">
          <div class="head-nav h-3 clearFloat">
            <span class="c-normal">{{$t("Crmactivemanage.bw")}}</span>
            <div class="pull-right">
              <el-button type="warning" @click="handAdd()">{{$t("Crmactivemanage.bss")}}</el-button>
              <el-button type="primary" @click="daochu">{{$t("Crmactivemanage.by")}}</el-button>
            </div>
          </div>
        </div>
        <div class="crmTicketMange-container">
          <div class="content">
            <div class="flex-wrap">
              <div class="flex-al mb20 mr10">
                <span class="mr10 fs14 color-666">{{$t("Crmactivemanage.bz")}}</span>
                <div class="select-box" style="width:170px;">
                  <el-select
                    v-model="selectForm.ticket_status"
                    clearable
                    filterable
                    :placeholder="$t('Crmactivemanage.ca')"
                    @change="handleSelect()"
                  >
                    <el-option :label="$t('Crmactivemanage.ak')" value></el-option>
                    <el-option :label="$t('Crmactivemanage.cb')" value="0"></el-option>
                    <el-option :label="$t('Crmactivemanage.cc')" value="1"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al Inquire-box mb20">
                <div class="ipt-box">
                  <el-input
                    v-model="selectForm.keyword"
                    class="input-cont"
                    clearable
                    placeholder="可检索招生券编号"
                    @change="handleSelect()"
                  ></el-input>
                </div>
                <el-button
                  type="primary"
                  class="btn-inquire fs14"
                  @click="handleSelect()"
                >{{$t("Crmactivemanage.as")}}</el-button>
              </div>
            </div>
            <div class="tableDiv" ref="auto_height_table">
              <normalTableCont :tableData="tableListTicket" @handSetting="handSetting"></normalTableCont>
              <!-- 分页 -->
              <el-pagination
                style="margin: 10px;"
                :current-page.sync="paging.curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size.sync="paging.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.pageTotal"
                @current-change="curPageChange"
                @size-change="pageSizeChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </PageNav>

    <!-- 生成招生券 -->
    <el-dialog
      :title="$t('Crmactivemanage.ce')"
      :visible.sync="ticketItem"
      class="tan-binding"
      width="500px"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="95px"
          :model="ticketForm"
          ref="ticketForm"
          :rules="ticketRules"
          style="padding:0px"
        >
          <el-form-item :label="$t('Crmactivemanage.bt')" prop="ticket_name">
            <el-input
              v-model="ticketForm.ticket_name"
              style="width: 300px;"
              :placeholder="$t('Crmactivemanage.cf')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Crmactivemanage.bss')" prop="ticket_note">
            <el-input
              type="textarea"
              clearable
              v-model="ticketForm.ticket_note"
              :placeholder="$t('Crmactivemanage.cg')"
              style="width:300px;"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Crmactivemanage.ch')" style="width: 395px;" required>
            <el-col :span="11">
              <el-form-item prop="ticket_starttime">
                <el-date-picker
                  type="date"
                  :placeholder="$t('Crmactivemanage.ad')"
                  value-format="yyyy-MM-dd"
                  v-model="ticketForm.ticket_starttime"
                  :picker-options="pickerOptionsStartCreate"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col class="line" :span="2">-</el-col> -->
            <el-col :span="2" style="padding-left: 3px;">{{$t("Crmactivemanage.ae")}}</el-col>
            <el-col :span="11">
              <el-form-item prop="ticket_endtime">
                <el-date-picker
                  type="date"
                  :placeholder="$t('Crmactivemanage.cf')"
                  :picker-options="pickerOptionsEndCreate"
                  value-format="yyyy-MM-dd"
                  v-model="ticketForm.ticket_endtime"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('Crmactivemanage.ci')" prop="num">
            <el-input
              v-model="ticketForm.num"
              style="width: 300px;"
              :placeholder="$t('Crmactivemanage.cj')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTicketSubmit()">{{$t("Crmactivemanage.bc")}}</el-button>
        <el-button @click="ticketItem = false">{{$t("Crmactivemanage.bb")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import normalTableCont from "../../components/tables/normalTableCont.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";

export default {
  name: "Crmactivemanage-crmTicketMange",
  data() {
    return {
      basicinformation: [],
      dialogimgVisible: false,
      activityId: "", //暂存查看的活动id
      infoForm: {
        a_content: "",
        editorOption: {}
      },
      //招生券描述
      ticketForm: {
        ticket_name: "", //券名称
        ticket_note: "", //备注
        ticket_starttime: "", //有效开始时间
        ticket_endtime: "", //有效结束时间
        num: "" //个数
      },
      //招生券描述*****校验规则
      ticketRules: {
        ticket_name: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cf"),
            trigger: "blur"
          }
        ],
        ticket_note: [{ required: false, trigger: "blur" }],
        ticket_starttime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.ck"),
            trigger: "change"
          }
        ],
        ticket_endtime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cl"),
            trigger: "change"
          }
        ],
        num: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cj"),
            trigger: "blur"
          }
        ]
      },
      //时间选择排序
      pickerOptionsStartCreate: {
        disabledDate: time => {
          if (this.ticketForm.ticket_endtime) {
            return (
              time.getTime() <
              new Date(this.ticketForm.ticket_endtime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      pickerOptionsEndCreate: {
        disabledDate: time => {
          if (this.ticketForm.ticket_starttime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <=
                new Date(this.ticketForm.ticket_starttime).getTime()
            );
          } else {
            return (
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() >=
                new Date(this.ticketForm.ticket_starttime).getTime()
            );
          }
        }
      },
      //筛选条件--招生券管理
      selectForm: {
        ticket_status: "",
        keyword: ""
      },
      //招生券管理
      ticketItem: false, //生成招生券
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 0
        }
      },
      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 10
      },
      // 招生券管理表格数据
      tableListTicket: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: "300px" //表格高度
        }
      }
    };
  },
  components: {
    PageNav,
    normalTableCont
  },
  updated() {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.activity_id = this.$route.query.id;
    this.getenrollTicketData(); //招生券管理
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    //招生券管理
    getenrollTicketData() {
      CrmActiveManage.enrollTicketList({
        activity_id: this.activity_id,
        school_id: this.school_id,
        import: this.import,
        p: this.paging.curPage,
        num: this.paging.pageSize,
        is_count: "1", //是否需要总数，可以不传
        //筛选条件
        keyword: this.selectForm.keyword,
        ticket_status: this.selectForm.ticket_status //使用状态 0未使用1已使用
      }).then(res => {
        this.tableListTicket.columns = res.data.data.field;
        this.paging.pageTotal = parseInt(res.data.data.all_num);
        this.tableListTicket.options.loading = false;
        this.tableListTicket.options.errortip = res.data.msg;
        if (res.data.code === 200) {
          this.tableListTicket.list = res.data.data.list;
        } else {
          this.tableListTicket.list = [];
        }
      });
    },
    // 生成招生券提交
    onTicketSubmit() {
      this.$refs["ticketForm"].validate(valid => {
        if (valid) {
          CrmActiveManage.createEnrollTicketAction({
            company_id: this.company_id,
            school_id: this.school_id,
            activity_id: this.activity_id,
            ticket_name: this.ticketForm.ticket_name,
            ticket_note: this.ticketForm.ticket_note,
            ticket_starttime: this.ticketForm.ticket_starttime,
            ticket_endtime: this.ticketForm.ticket_endtime,
            num: this.ticketForm.num
          }).then(res => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
              this.ticketItem = false;
              this.getenrollTicketData();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 选择单个活动招生券
    handleSelect() {
      this.paging.curPage = 1;
      this.getenrollTicketData();
    },
    // 点击生成招生券
    handAdd() {
      this.ticketItem = !this.ticketItem;
      if (this.$refs["ticketForm"]) {
        this.$refs["ticketForm"].resetFields();
      }
    },
    // 编辑列编辑提交
    handSetting(v) {
      (() => {})(v);
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.getenrollTicketData();
    },
    // pageSize改变
    pageSizeChange() {
      this.paging.curPage = 1;
      this.getenrollTicketData();
    },
    handleClose(done) {
      done();
    },
    // 导出操作
    daochu() {
      let url = CrmActiveManage.enrollTicketList1();
      var is_import = 1;
      let language_type = this.$Tool.getStorage("language")
        ? this.$Tool.getStorage("language")
        : "zh";
      (() => {})(
        `${url}?marketer_id=${this.marketer_id}&token=${this.token}&activity_id=${this.activity_id}&school_id=${this.school_id}&company_id=${this.company_id}&import=${is_import}&keyword=${this.selectForm.keyword}&ticket_status=${this.selectForm.ticket_status}&language_type=${language_type}`
      );
      if (this.tableListTicket.list.length > 0) {
        window.open(
          `${url}?marketer_id=${this.marketer_id}&token=${this.token}&activity_id=${this.activity_id}&school_id=${this.school_id}&company_id=${this.company_id}&import=${is_import}&keyword=${this.selectForm.keyword}&ticket_status=${this.selectForm.ticket_status}&language_type=${language_type}`,
          "_blank"
        );
      } else {
        this.$message.error(this.$t("Crmactivemanage.cm"));
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableListTicket.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  }
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");
.Crmactivemanage-crmTicketMange {
  height: 100vh;
  font-size: 14px;
  .tan-code {
    .code {
      text-align: center;
      width: 70%;
      margin: 0 auto;
      img {
        display: block;
        width: 100%;
        margin: 0 auto;
      }
      p {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog {
      margin-top: 24vh;
    }
  }
  .code {
    width: 200px;
    text-align: center;
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
}
</style>
